var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "sticky-container",
          attrs: { shadow: "never", "body-style": { padding: 0 } },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleFilter },
                  model: {
                    value: _vm.queryParams.state,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "state", $$v)
                    },
                    expression: "queryParams.state",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "所有商家", name: "-1" },
                  }),
                  _c("el-tab-pane", { attrs: { label: "未审核", name: "0" } }),
                  _c("el-tab-pane", {
                    attrs: { label: "审核通过", name: "1" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "审核失败", name: "2" },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "filter-container", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 6 } },
                    [
                      _c("el-input", {
                        staticClass: "filter-item",
                        attrs: { placeholder: "商家名称", clearable: "" },
                        model: {
                          value: _vm.queryParams.keyword,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "keyword", $$v)
                          },
                          expression: "queryParams.keyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 3 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-item",
                          attrs: { placeholder: "系统状态", clearable: "" },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "禁用", value: 0 },
                          }),
                          _c("el-option", {
                            attrs: { label: "启用", value: 1 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 9 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v("查找")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "danger", icon: "el-icon-edit" },
                          on: { click: _vm.handleCreate },
                        },
                        [_vm._v("增加商家")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                { name: "sticky-header", rawName: "v-sticky-header" },
              ],
              attrs: {
                stripe: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
                "header-cell-class-name": "table-header-cell",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "60",
                  align: "center",
                  type: "index",
                  "class-name": "table-header-cell",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商家名称",
                  prop: "shopName",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "所属地区", prop: "regionName", width: "200" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "详细地址",
                  prop: "address",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "优惠折扣",
                  prop: "discount",
                  width: "80",
                  align: "right",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排序",
                  prop: "sortBy",
                  width: "80",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "推荐人", prop: "inviterName", width: "150" },
              }),
              _c("el-table-column", {
                attrs: { label: "推荐码", prop: "inviteCode", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { label: "创建时间", prop: "createTime", width: "150" },
              }),
              _c(
                "el-table-column",
                {
                  attrs: { label: "系统状态", width: "80", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("el-switch", {
                            staticClass: "rectangle md",
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            on: {
                              change: function ($event) {
                                return _vm.handleUpdate(row)
                              },
                            },
                            model: {
                              value: row.status,
                              callback: function ($$v) {
                                _vm.$set(row, "status", $$v)
                              },
                              expression: "row.status",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [_vm._v('" ')]
              ),
              _c("el-table-column", {
                attrs: { label: "审核状态", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm._f("checkType")(row.auditState),
                              effect: "dark",
                            },
                          },
                          [_vm._v(_vm._s(_vm._f("checkText")(row.auditState)))]
                        ),
                        row.auditState === 2 && row.auditComment
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: row.auditComment,
                                  placement: "bottom",
                                  effect: "light",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "tool-tip-icon el-icon-warning-outline",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", width: "80", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v(" 操作"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      disabled: scope.row.auditState !== 0,
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleApprove(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-check" }),
                                    _vm._v(" 商家审核"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: { divided: "" },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleDetail(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-more" }),
                                    _vm._v(" 商家详情"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleEdit(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-edit" }),
                                    _vm._v(" 编辑商家"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleRemove(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-delete" }),
                                    _vm._v(" 删除商家"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleReset(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-refresh" }),
                                    _vm._v(" 重置密码"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      disabled:
                                        scope.row.auditState !== 1 ||
                                        scope.row.status !== 1,
                                      divided: "",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleGoods(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-goods" }),
                                    _vm._v(" 商品列表"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      disabled:
                                        scope.row.auditState !== 1 ||
                                        scope.row.status !== 1,
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleNewGoods(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-present" }),
                                    _vm._v(" 添加商品"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      disabled:
                                        scope.row.auditState !== 1 ||
                                        scope.row.status !== 1,
                                      divided: "",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleEmployee(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-user" }),
                                    _vm._v(" 店员管理"),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.approveLoading,
              expression: "approveLoading",
            },
          ],
          attrs: {
            title: "商家审核",
            width: "80%",
            top: "5vh",
            "destroy-on-close": "",
            "custom-class": "dialog-scrollbar",
            visible: _vm.dialogVisible,
            fullscreen: _vm.device === "mobile",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-popover",
                    {
                      attrs: { title: "审核不通过", placement: "top" },
                      on: {
                        hide: function ($event) {
                          _vm.approveMessage = ""
                        },
                      },
                      model: {
                        value: _vm.approveVisible,
                        callback: function ($$v) {
                          _vm.approveVisible = $$v
                        },
                        expression: "approveVisible",
                      },
                    },
                    [
                      _c(
                        "p",
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入不通过的理由",
                              clearable: "",
                            },
                            model: {
                              value: _vm.approveMessage,
                              callback: function ($$v) {
                                _vm.approveMessage = $$v
                              },
                              expression: "approveMessage",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex align-center just-end" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "medium" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.approveVisible = false
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.onApproved(2)
                                },
                              },
                            },
                            [_vm._v("确定")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "reference", type: "info" },
                          slot: "reference",
                        },
                        [_vm._v("不通过")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onApproved(1)
                        },
                      },
                    },
                    [_vm._v("审核通过")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("store-review", {
            attrs: { "store-id": _vm.storeId, "can-edit": false },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }